import { useBandshopConfig } from 'context/BandshopConfigContex';
import { useMemo } from 'react';
import { ProgramType } from 'utils/enum';
import { Platform } from 'utils/platform';

type Program = {
  bandshopOffers?: {
    isDisabled?: boolean;
  };
};

export function useBandshopVisible(programType: ProgramType, program?: Program): boolean {
  const bandshopConfig = useBandshopConfig();

  return useMemo(() => {
    const isTv = Platform.isTV;
    const allOffersDisabled = bandshopConfig?.offersAvailabilitySettings?.areAllOffersDisabled;
    const isTypeDisabled =
      bandshopConfig?.offersAvailabilitySettings?.disableOffersPerType?.[programType];
    const isProgramDisabled = program?.bandshopOffers?.isDisabled;

    return !isTv && !allOffersDisabled && !isTypeDisabled && !isProgramDisabled;
  }, [programType, bandshopConfig, program]);
}
